import View from 'view/view'
import Router from 'service/router'
import sayHiTemplate from 'component/header/template/say_hi.tmpl'
import TwinkleListView from 'component/header/view/twinkle_list'

import Counter from 'component/counter/model/counter'
import CounterView from 'component/counter/counter'
import CounterBadgeView from 'component/counter/badge'

import alertCounter from 'shared/model/alert_counter'

const TwinklesView = View.extend({
    template: sayHiTemplate,

    initialize() {
        this.counter = new Counter({
            maxCount: 99,
            count: alertCounter.get('twinkleCount'),
        })

        this.listenTo(alertCounter, 'change:twinkleCount', function() {
            this.counter.set({ count: alertCounter.get('twinkleCount') })
        })

        this.listenTo(this.collection, 'request sync', this.render)
    },

    render() {
        this.destroySubviews()

        this.$el.html(
            this.template({
                twinkles: {
                    loading: this.collection.isFetching(),
                    total: alertCounter.get('twinkleCount'),
                },
                link: {
                    allTwinkles: Router.path('spa_say_hi_index', null, {
                        query: { ref: 'he_tw' },
                    }),
                },
            })
        )

        this.initSubview(
            TwinkleListView,
            {
                el: this.$('.js-twinkles-list'),
                collection: this.collection,
            },
            { remove: 'content' }
        ).render()

        if (this.counter.get('count')) {
            this.initSubview(
                CounterBadgeView,
                {
                    el: this.$('.js-count-header'),
                    model: this.counter,
                },
                { remove: 'content' }
            ).render()

            this.initSubview(
                CounterView,
                {
                    el: this.$('.js-count-results'),
                    model: this.counter,
                },
                { remove: 'content' }
            ).render()
        }

        return this
    },
})

export default TwinklesView
